export const ENV = process.env.REACT_APP_ENV;
export const LOCALE = process.env.REACT_APP_LOCALE;
export const BREATHE_ID_TOKEN = process.env.REACT_APP_BREATHE_ID_TOKEN;
export const SINGUP_URL= process.env.REACT_APP_SIGNUP_URL;

export const COGNITO_URL = process.env.REACT_APP_COGNITO_URL;

export const INTERCOM_2FA_HELP_ARTICLE = process.env.REACT_APP_INTERCOM_2FA_HELP_ARTICLE

export const LOGIN_APP_ID = process.env.REACT_APP_LOGIN_APP_ID;

export const ROTA_APP_URL = process.env.REACT_APP_ROTA_APP_URL;
export const HR_APP_URL = process.env.REACT_APP_HR_URL;

export const SHOW_WARNING = process.env.REACT_APP_SHOW_WARNING;

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
export const COGNITO_USER_POOL_WEB_CLIENT_ID = process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID;

export const BREATHE_BLUE = "#0580FA";

// ALLOWED_BASE_DOMAINS maps a recognised base domain to its API host. The
// values are the real provisioned API hostnames (source of truth: the
// preview-prod Terraform in the infrastructure repo) - never derive them
// by templating a prefix onto the base domain, since the AU estate uses
// login-api. and a template would silently produce the wrong host if
// this were ever pointed there. Only the two GB hosts this PR is scoped
// to are listed - staging and AU are handled by the baked fallback
// below, not by growing this map.
export const ALLOWED_BASE_DOMAINS = {
  "breathehr.com": "loginapi.breathehr.com",
  "breathehrpreview.com": "loginapi.breathehrpreview.com",
};

const isLocalDevHost = (hostname) => {
  const host = hostname || "";
  return (
    host === "localhost" ||
    host === "breathehr.localhost" ||
    host.endsWith(".breathehr.localhost")
  );
};

// Reads process.env.REACT_APP_ENV fresh (rather than the frozen ENV
// export above) so tests can flip it per-case without jest.resetModules.
const isDev = (hostname) => {
  const env = process.env.REACT_APP_ENV;
  return env === "development" || env === "test" || isLocalDevHost(hostname);
};

// The baked triple this build shipped with. This is the fallback for both
// local dev AND any host this build's ALLOWED_BASE_DOMAINS doesn't
// recognise (staging, AU, or anything else) - never a synthesised GB
// production URL, which would silently misroute a non-GB build's
// credentialed requests to the wrong environment.
const bakedHostConfig = () => ({
  breatheDomain: process.env.REACT_APP_BREATHE_DOMAIN,
  loginApiUrl: process.env.REACT_APP_LOGIN_API_URL,
  loginAppUrl: process.env.REACT_APP_LOGIN_APP_URL,
});

// Resolves hostname to one of ALLOWED_BASE_DOMAINS' keys via an exact
// match on its last two labels - never a string template and never an
// unguarded endsWith/substring check, either of which a hostname like
// "evilbreathehr.com" or "login.breathehr.com.evil.com" could spoof.
// Returns null (never a guess, never the raw hostname) when there is no
// exact allowlist match, so the caller falls back to this build's own
// baked values.
const resolveBaseDomain = (hostname) => {
  const candidate = (hostname || "").split(".").slice(-2).join(".");
  return Object.prototype.hasOwnProperty.call(ALLOWED_BASE_DOMAINS, candidate)
    ? candidate
    : null;
};

// Pure and side-effect free (see src/constants.test.js) - BREATHE_DOMAIN,
// LOGIN_API_URL and LOGIN_APP_URL below call this once with the real
// window.location.hostname at import time.
export const deriveHostConfig = (hostname) => {
  if (isDev(hostname)) {
    return bakedHostConfig();
  }

  const baseDomain = resolveBaseDomain(hostname);

  if (!baseDomain) {
    return bakedHostConfig();
  }

  return {
    breatheDomain: baseDomain,
    loginApiUrl: `https://${ALLOWED_BASE_DOMAINS[baseDomain]}`,
    loginAppUrl: `https://login.${baseDomain}`,
  };
};

const hostConfig = deriveHostConfig(window.location.hostname);

export const BREATHE_DOMAIN = hostConfig.breatheDomain;
export const LOGIN_API_URL = hostConfig.loginApiUrl;
export const LOGIN_APP_URL = hostConfig.loginAppUrl;